import Reveal from "@/components/base/Reveal";
import { dramaMeta, plotParagraphs } from "@/mocks/drama";

const quickFacts = [
  { icon: "ri-movie-2-line", label: "题材类型", value: dramaMeta.genre },
  { icon: "ri-stack-line", label: "剧情体量", value: "全 36 集主线脉络" },
  { icon: "ri-map-pin-time-line", label: "故事舞台", value: "都市 · 职场与家庭之间" },
];

export default function PlotOverview() {
  return (
    <section id="overview" className="w-full bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-14">
          <div className="lg:col-span-7">
            <Reveal>
              <p className="flex items-center gap-2 font-label text-sm tracking-[0.3em] text-primary-600">
                <i className="ri-book-open-line" />
                剧 情 介 绍
              </p>
              <h2 className="mt-4 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-4xl">
                这部剧讲的到底是什么
              </h2>
              <p className="mt-5 text-sm leading-relaxed text-foreground-600 md:text-base">
                {dramaMeta.tagline}
              </p>
            </Reveal>

            <div className="mt-8 space-y-5">
              {plotParagraphs.map((para, idx) => (
                <Reveal key={`plot-${idx}`} delay={idx * 80}>
                  <p className="text-sm leading-loose text-foreground-700 md:text-[15px]">
                    {para}
                  </p>
                </Reveal>
              ))}
            </div>

            <Reveal delay={120}>
              <div className="mt-8 flex items-start gap-3 rounded-lg border border-secondary-200 bg-secondary-50 p-4 md:p-5">
                <i className="ri-lightbulb-line mt-0.5 text-lg text-accent-600" />
                <p className="text-xs leading-relaxed text-secondary-900 md:text-sm">
                  阅读建议：先看本节的剧情介绍建立整体印象，再按顺序读「大结局解析」与「分集剧情」，理解会更连贯。
                </p>
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-5">
            <Reveal delay={100}>
              <div className="overflow-hidden rounded-lg border border-background-200 bg-background-100">
                <div className="h-64 w-full md:h-72">
                  <img
                    src="https://readdy.ai/api/search-image?query=Elegant%20cinematic%20still%20life%20of%20a%20single%20deep%20red%20rose%20with%20soft%20dew%20drops%20on%20a%20dark%20reflective%20surface%2C%20warm%20amber%20rim%20lighting%2C%20moody%20dramatic%20shadows%20in%20the%20background%2C%20luxury%20editorial%20photography%2C%20rich%20burgundy%20and%20gold%20tones%2C%20no%20people&width=800&height=640&seq=drama-rose-still&orientation=landscape"
                    alt="深红玫瑰置于暗色反光台面，暖金色边缘光营造朦胧氛围，呼应欲望主题"
                    className="h-full w-full object-cover object-top"
                  />
                </div>
                <div className="divide-y divide-background-200">
                  {quickFacts.map((fact) => (
                    <div key={fact.label} className="flex items-center gap-3 px-5 py-4">
                      <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-primary-100 text-lg text-primary-600">
                        <i className={fact.icon} />
                      </span>
                      <div>
                        <p className="text-xs text-foreground-500">{fact.label}</p>
                        <p className="mt-0.5 text-sm font-medium text-foreground-900">{fact.value}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}